<app-pane [title]="title">
  <div class="list-section">
    <select #featureSelect [value]="selectedId" (change)="selectedIdChanged(featureSelect.value)">
      <option *ngFor="let item of items" [value]="item.id">{{item.name}}</option>
    </select>
    <button *ngIf="canAdd" (click)="addClicked()">+</button>
    <button *ngIf="canDelete" (click)="deleteClicked()">-</button>
  </div>
  <ng-content></ng-content>
</app-pane>
